import React, { useContext } from 'react';
import pt from 'prop-types';
import Headline, { headlinePropTypes } from '../../../../../ui/headline';
import CountryTableRow from '../rankingTableRow';
import * as styles from './styles.module.scss';
import Container from '../../../../../../modules/container';
import Link from '../../../../../ui/link';
import { MicrocopyContext } from '../../../../../../context/microcopy.context';
import { getCopy } from '../../../../../../helpers/copy';
import { STATIC_ROUTES } from '../../../../../../utils/constants';

const RankingTabPanel = ({ items, headline, type }) => {
  const microcopy = useContext(MicrocopyContext);

  return (
    <div className={styles.outerContainer}>
      <Container>
        <Headline text={headline} level="h2" type="h1" className={styles.hl} />
        <div>
          {items?.slice(0, 10).map((item, index) => (
            <CountryTableRow
              data={item}
              index={index}
              key={index}
              type={type}
            />
          ))}
        </div>
        <div className={styles.button}>
          <Link
            link={{
              linkToPage: STATIC_ROUTES.WDI_FILTER_PAGE,
              queryParameter: `?dynamicFilterId=${items?.[0]?.continent}`,
            }}
            asButton
          >
            {getCopy('btn.showAll', microcopy)}
          </Link>
        </div>
      </Container>
    </div>
  );
};

RankingTabPanel.propTypes = {
  items: pt.array.isRequired,
  headline: pt.shape(headlinePropTypes).isRequired,
  type: pt.oneOf(['sectors', 'company']),
};

RankingTabPanel.defaultProps = {
  type: 'company',
};

export default RankingTabPanel;
